import { Injectable, signal } from '@angular/core';
import { Selection } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class SelectionStateService {
  #selections = signal<Selection[]>([]);

  setSelections(list: Selection[]): void {
    this.#selections.set(list);
  }

  selections(): Selection[] {
    return this.#selections();
  }

  addPostToSelection(selectionId: number, postUuid: string): void {
    this.#selections.update(list =>
      list.map(s => s.id === selectionId
        ? { ...s, posts_uuids: [...s.posts_uuids, postUuid] }
        : s)
    );
  }

  removePostFromSelection(selectionId: number, postUuid: string): void {
    this.#selections.update(list =>
      list.map(s => s.id === selectionId
        ? { ...s, posts_uuids: s.posts_uuids.filter(u => u !== postUuid) }
        : s)
    );
  }

  addSelection(selection: Selection): void {
    this.#selections.update(list => [...list, selection]);
  }
}
